import React from "react";
import { Tooltip } from "@mui/material";
import DateRangeIcon from "@mui/icons-material/DateRange";

const formatDate = (date) => {
  const [year, month, day] = String(date).slice(0, 10).split("-");
  return `${month}/${day}/${year}`;
};

// Marks a class that uses a custom active period (klass_terms available time).
export default function AvailableTimeIcon({ start, end }) {
  if (!start || !end) return null;

  return (
    <Tooltip
      title={`This class uses a custom active period: ${formatDate(
        start
      )} - ${formatDate(end)}`}
    >
      <DateRangeIcon fontSize="inherit" />
    </Tooltip>
  );
}
